import React from 'react';
import FeedbackForm from '@components/navigator/FeedbackForm';

const NavigatorFeedbackDialog = ({ children }) => {
  return <FeedbackForm>{children}</FeedbackForm>;
};

export default NavigatorFeedbackDialog;
